import { useRoles } from "Settings/User/Api/Query/useUserRoleByName";
import { UserRolesEditForm } from "Settings/User/Components/Form/UserRolesEditForm";
import { Loading } from "Shared/Components/Loading/Loading";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router";

export const UserRolesEdit = () => {
	const [searchParams] = useSearchParams();
	const paramsRole = searchParams.get("role");
	const role = paramsRole ? decodeURIComponent(String(paramsRole)) : undefined;

	const { data, isLoading } = useRoles(role);

	return (
		<>
			{isLoading && (
				<Stack width="100%" alignItems="center">
					<Loading />
				</Stack>
			)}
			{data && <UserRolesEditForm data={data} />}
		</>
	);
};
